<script setup>
import xButton from '@/components/common/xButton.vue'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { useTheme } from '~/hooks/theme'
import { inApp } from '@/utils/inApp'

const breakpoints = useBreakpoints(breakpointsTailwind)
const smAndSmaller = breakpoints.smallerOrEqual('sm') // <= 640
const theme = useTheme()
const router = useRouter()
const { locale } = useI18n()

const show = computed(() => {
  if (import.meta.client) {
    if (inApp) {
      return false
    }
    else if (smAndSmaller.value) {
      return true
    }
    return false
  }
  return false
})

function handleOpenApp() {
  if (import.meta.client && !inApp) {
    try {
    // 尝试打开应用链接
      const newWindow = window.open('ttxapp://', '_self')

      // 超时检测：如果 2 秒后未唤起应用，跳转到下载页面
      setTimeout(() => {
        if (!newWindow.closed) {
          router.push(`/${locale.value}/download`)
        }
      }, 2000)
    }
    catch (error) {
      router.push(`/${locale.value}/download`)
    }
  }
}
</script>

<template>
  <div v-if="show" class="w-[100%] px-[16px] py-[12px] bg-fillPagePrimary flex justify-between items-center border-b  border-dividerPrimary">
    <div class="flex gap-[8px]">
      <svgo-common-app-light-logo v-if="theme === 'dark'" class="w-[40px] h-[40px]" />
      <svgo-common-app-logo v-else class="w-[40px] h-[40px]" />
      <div class="flex flex-col">
        <span class="text-textPrimary text-sm font-semibold">TT APP</span>
        <span class="text-textSecondary text-xs">{{ $t('在 TT 探索未来金融高效投资交易') }}</span>
      </div>
    </div>
    <xButton class="w-[80px] h-[32px] whitespace-nowrap" @click="handleOpenApp">
      {{ $t('下载') }}
    </xButton>
  </div>
</template>
